import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  fieldsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    alignSelf: 'stretch',
  },

  field: {
    width: '459.5px',
    textAlign: 'left',
  },
  arnHelperRow: {
    marginTop: theme.spacing(0.5),
    minHeight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
  },
  arnHintText: {
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    letterSpacing: '0.1px',
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.labraText.description,
  },
  loadingText: {
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    letterSpacing: '0.1px',
    fontFamily: theme.typography.fontFamily,
  },
  textColor: {
    color: theme.palette.labraText.description,
  },
  successText: {
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    letterSpacing: '0.1px',
    fontFamily: theme.typography.fontFamily,
  },
  loadingTextContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  loader: {
    width: '16px',
    height: '16px',
    flexShrink: 0,
    color: theme.palette.syncStatus.success,
  },
  check: {
    color: theme.palette.textBackground.dark,
  },
  buttonContainer: {
    marginTop: theme.spacing(0.625),
  },
  errorText: {
    color: theme.palette.labraV2Errors.main,
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    letterSpacing: '0.1px',
    fontFamily: theme.typography.fontFamily,
  },
  content: {
    display: 'flex',
    gap: `${theme.spacing(5)} !important`,
    flexDirection: 'row',
  },
  fieldsArnContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
  arnInputAndStatus: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5), // 4px
  },
  tryAgain: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(0.375),
  },
  tryAgainText: {
    fontSize: '12px',
    color: theme.palette.select.light,
    cursor: 'pointer',
  },
  cross: {
    color: theme.palette.labraV2Errors.main,
  },
  verticalDevider: {
    width: theme.spacing(0.125),
    height: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    alignSelf: 'stretch',
    background: theme.palette.dividerV2.main,
    margin: theme.spacing(0, 1),
  },
}))
